import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../../redux";
import { Person, Entity, GRAPHQL_TYPE_PERSON, GRAPHQL_TYPE_ENTITY } from "@radivision/graphql";
import isEmpty from "lodash.isempty";
import "./about.scss";
import { isOwner } from "../../../../utilities/is-owner";

interface ComponentProps {
  subject: Person | Entity;
}

interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapStateProps;

export const NoContentComponent = (props: React.PropsWithChildren<Props>) => {
  const { subject, user, children } = props;
  const isPerson = subject?.__typename === GRAPHQL_TYPE_PERSON;
  const isCompany = subject?.__typename === GRAPHQL_TYPE_ENTITY;
  const person = isPerson ? (subject as Person) : null;
  const entity = isPerson ? (subject as Entity) : null;

  const personHasNoContent =
    isPerson && isEmpty(person?.description) && isEmpty(person.entities) && isEmpty(person.experience?.edges);

  const ownPerson = person?.id === user?.id;
  const ownEntity = isOwner(entity, user);

  if (person && ownPerson && personHasNoContent) {
    return (
      <>
        <h2 className="no-content">
          Your profile is missing its about information.
          <br />
          Please use &ldquo;Edit Profile&rdquo; button to add this important information now. Thank you!
        </h2>
        {children}
      </>
    );
  }
  if (person && !ownPerson && personHasNoContent) {
    return <h2 className="no-content">No information is available yet about &ldquo;{person?.fullName}&rdquo;.</h2>;
  }

  const entityHasNoContent =
    isCompany &&
    entity &&
    isEmpty(entity?.description) &&
    isEmpty(entity?.noOfEmployees) &&
    isEmpty(entity?.industry) &&
    isEmpty(entity?.activities);

  if (entity && ownEntity && entityHasNoContent) {
    return (
      <h2 className="no-content">
        Your company&rsquo;s profile is missing its about information.
        <br />
        Please use &ldquo;Edit Profile&rdquo; button to add more information about your company.
      </h2>
    );
  }

  if (entity && !ownEntity && entityHasNoContent) {
    return (
      <h2 className="no-content">
        &ldquo;{entity?.name}&rdquo; has not yet uploaded this information. If you are interested in being notified when
        they do, please share your email address and we will contact you as soon as it is available. Thank you!
      </h2>
    );
  }

  return children;
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const NoContent = connect(mapState, mapDispatch)(NoContentComponent);
